import { List } from 'immutable';
import { Ingredients } from 'records/Ingredient';
import BaseList from 'records/BaseList';

import {
  SYSCO_PRODUCTS_ASYNC_ACTION_START,
  SYSCO_PRODUCTS_ASYNC_ACTION_ERROR,
  SYSCO_PRODUCTS_ASYNC_ACTION_SUCCESS,
  SYSCO_PRODUCTS_RESET_STATE,
  SYSCO_PRODUCT_REMOVE,
  SYSCO_PRODUCTS_REMOVE_RECIPE_PRODUCTS,
} from 'actions/syscoProducts';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [SYSCO_PRODUCTS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [SYSCO_PRODUCTS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [SYSCO_PRODUCTS_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: Ingredients(action.data),
    });
  },
  [SYSCO_PRODUCT_REMOVE]: (state, action) => {
    const originalList = state.get('data');
    const list = originalList.filter((ingredient) => {
      return !(action.data.removedIngredientSupc === (ingredient.get('supc')) && ingredient.get('usedInRecipes').length === 1
        && (ingredient.get('usedInRecipes')[0].recipeId.toString() === action.data.recipeId));
    })

    let ingredients = list.map((ingredient) => {
      if (ingredient.get('supc') === action.data.removedIngredientSupc) {
        const filterUsedInRecipes = ingredient.get('usedInRecipes').filter((recipe) => {
          return recipe.recipeId.toString() !== action.data.recipeId
        });
        return ingredient.set('usedInRecipes', filterUsedInRecipes);
      }
      else {
        return ingredient;
      }
    });

    return state.merge({
      data: ingredients
    })
  },
  [SYSCO_PRODUCTS_REMOVE_RECIPE_PRODUCTS]: (state, action) => {
    const originalList = state.get('data');
    const list = originalList.filter((ingredient) => {
      return !(ingredient.get('usedInRecipes').length === 1 && (ingredient.get('usedInRecipes')[0].recipeId === action.data.recipeId));
    })

    let ingredients = list.map((ingredient) => {
      const filterUsedInRecipes = ingredient.get('usedInRecipes').filter((recipe) => {
        return recipe.recipeId !== action.data.recipeId
      });
      return ingredient.set('usedInRecipes', filterUsedInRecipes);
    });

    return state.merge({
      data: ingredients
    })
  },
  [SYSCO_PRODUCTS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function syscoProducts(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
